import { useTranslation } from 'react-i18next';
import { Trip } from '../../Summary.model';
import { SummarySubItem } from '../summary-sub-item/SummarySubItem';
import { SummaryArticle } from '../summary-article/SummaryArticle';
import { SummaryAccordion } from '../summary-accordion/SummaryAccordion';
import { SummaryItem } from '../summary-item/SummaryItem';
import { getFareItemIcon } from '../../Summary.utils';
import { SummaryTripSegment } from '../summary-trip-segment/SummaryTripSegment';

type TripItemProps = { trip: Trip; indexTrip: number; isMultiTrip: boolean; collapsed: boolean };

export const SummaryTrip = (props: TripItemProps) => {
	const { t } = useTranslation('summary');
	const { trip, indexTrip, isMultiTrip = false, collapsed = false } = props;
	return (
		<>
			<SummaryItem
				title={
					isMultiTrip
						? `${String(t('JOURNEY'))} ${String(indexTrip + 1)}`
						: indexTrip === 0
							? t('OUTBOUND_JOURNEY')
							: t('RETURN_JOURNEY')
				}
				titleColor={isMultiTrip ? undefined : '#d7192d'}
				icon={isMultiTrip ? undefined : indexTrip === 0 ? 'go' : 'return'}
			>
				{trip.segments.map((segment) => (
					<SummaryTripSegment key={segment.id} segment={segment} collapsed={collapsed}></SummaryTripSegment>
				))}
			</SummaryItem>
			{!collapsed && (
				<SummaryItem>
					<SummarySubItem text={`${String(t('FARE'))} ${trip.fare.title}`}></SummarySubItem>
					<SummaryAccordion textShow={t('FARE_DETAILS_COLLAPSED')} textHide={t('FARE_DETAILS_HIDE')}>
						{trip.fare.items.map((item) => {
							return (
								<SummarySubItem key={item.code} icon={getFareItemIcon(item.code)} text={item.title}>
									<SummaryArticle text={item.text}></SummaryArticle>
								</SummarySubItem>
							);
						})}
					</SummaryAccordion>
				</SummaryItem>
			)}
		</>
	);
};
SummaryTrip.displayName = 'SummaryTrip';
